import React, {useEffect} from "react";
import "../../../ui-styles/conference/screenShare.css";

const ScreenShare = (props) => {

    // const [screen, setScreen] = useState(window.screenVideo);

    useEffect(() => {
        var screen_box = document.getElementById('screen_box');
        if(screen_box ) {
            screen_box.srcObject = props.screenStream;
        }
    },[props.screenStream]);
    
    return(
        <div className="topToolsContainer">
            <div className="scrnShrBlock">
                {/* {<div className="closeSS" onClick={()=>props.handleScreenShare()}></div>} */}
                <video id='screen_box' className="screen_box" autoPlay playsInline />
            </div>
        </div>
    )
}

export default ScreenShare;